import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';
export class Maintenancepage extends Component {
    displayName = Maintenancepage.name

    constructor(props) {
        super(props);
    }
    
    render() {
        const meta = {
            title: "Kluwer Law Online - Maintenance",
            canonical: window.location.href,
        }
        return (
            <div style={{ textAlign : "center" }}>
                <img src="/../../images/WK.png" alt="Logo of Wolters Kluwer, Kluwer Law Online" className="img" style={{ margin: '0px', padding : '5%' }}></img>
                <br /> <br /> 
                <i className="fa fa-exclamation-triangle" style={{ fontSize: '200px'}} aria-hidden="true"></i>
                <br/>
                <div style={{ fontSize: '25px' }}>Kluwer Law Online is currently not available due to maintenance work.</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/Maintenancepage.jsx